<template>
  <div id="texture-block" class="pb-12 rounded-lg">
    <div class=" block lg:flex flex-row">
      <div class="lg:w-2/5 text-center items-bottom">
        <h1 class="uppercase text-massive font-bebas text-green mt-16">
          WELCOME!
        </h1>
      </div>
      <div class="hidden lg:flex items-center justify-end w-full lg:w-3/5 ">
        <img src="/images/UGM_Logo.png" alt="" />
      </div>
    </div>
    <div class="block lg:flex px-4 lg:px-12">
      <div class="lg:w-2/5 px-2">
        <h2 class="text-center text-xl lg:text-3xl font-bold">
          To our first ever worldwide
        </h2>
        <h3 class="uppercase text-2xl lg:text-4xl font-semibold text-center">
          User Group Meeting
        </h3>
        <div class="prose text-md lg:text-lg font-semibold mt-4">
          <p>
            Thank you for joining us for our first ever worldwide User Group
            Meeting.
          </p>
          <p>
            We're sorry to say we have come to the end of our LIVE 2020
            worldwide User Group Meeting but what a journey it has been! All of
            this years sessions will remain available to watch, simply head over
            to the schedule page to view all of the topics.
          </p>
          <p>
            Please feel free to add any questions you may have in the comments
            section of each session, we'll be checking back to answer them
            regularly.
          </p>
        </div>
      </div>
      <div class="lg:w-60pc mx-auto px-2 mt-12 lg:mt-0">
        <video
          width="624"
          height="351"
          poster="/images/TakeTheTour_Thumbnail_3.jpg"
          class="mx-auto"
          controls
        >
          <source
            src="https://firebasestorage.googleapis.com/v0/b/usergroupmeeting-a7f47.appspot.com/o/public%2FMicrosite%20Tour.mp4?alt=media&token=8d28b5d0-3e59-4362-a724-7cbf62e37e3f"
            type="video/mp4"
          />
        </video>
        <!--        <img-->
        <!--          src="/images/TakeTheTour_Thumbnail_3.jpg"-->
        <!--          alt=""-->
        <!--          class="mx-auto"-->
        <!--        />-->
      </div>
    </div>

    <div class="block lg:flex flex-row px-6 my-12">
      <div class="lg:w-45pc">
        <paper-agenda></paper-agenda>
      </div>

      <div class="lg:-ml-10 -my-8 lg:my-0">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 730 964"
          style="max-width: 100%; width: 730px; height: auto"
          overflow="visible"
        >
          <defs>
            <filter id="shadowFilter">
              <feDropShadow dx="0" dy="0" stdDeviation="20" />
            </filter>
            <radialGradient id="g1">
              <stop offset="10%" stop-color="white" stop-opacity="50%" />
              <stop offset="70%" stop-color="white" stop-opacity="40%" />
              <stop offset="95%" stop-color="white" stop-opacity="0%" />
            </radialGradient>
            <radialGradient id="shadow">
              <stop offset="10%" stop-color="black" stop-opacity="40%" />
              <stop offset="70%" stop-color="black" stop-opacity="20%" />
              <stop offset="95%" stop-color="black" stop-opacity="0%" />
            </radialGradient>
            <radialGradient id="g2">
              <stop offset="10%" stop-color="#736daa" stop-opacity="40%" />
              <stop offset="70%" stop-color="#736daa" stop-opacity="20%" />
              <stop offset="95%" stop-color="#736daa" stop-opacity="0%" />
            </radialGradient>
          </defs>
          <image
            width="730"
            height="964"
            xlink:href="/images/map_new.png"
          ></image>

          <!-- Shop -->
          <circle
            class="cursor-pointer"
            @mouseover="overIcon('SHOP')"
            id="shop_hit_circle"
            opacity="0.0"
            fill="white"
            cx="140"
            cy="180"
            r="100"
          ></circle>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <!--            <circle-->
            <!--              v-show="show('SHOP')"-->
            <!--              cx="210"-->
            <!--              cy="222"-->
            <!--              r="350"-->
            <!--              style="fill: url(#shadow)"-->
            <!--            ></circle>-->
          </transition>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              @mouseout="outIcon('SHOP')"
              @click="$router.push('/purchase')"
              v-show="show('SHOP')"
              width="450"
              xlink:href="/images/SHOP_cutout.png"
              style="filter:url(#shadowFilter)"
              x="0"
              y="45"
              overflow="visible"
            ></image>
          </transition>

          <!-- Stage -->
          <circle
            class="cursor-pointer"
            @mouseover="overIcon('STAGE')"
            id="stage_hit_circle"
            opacity="0.0"
            fill="white"
            cx="600"
            cy="220"
            r="100"
          ></circle>
          <!--          <transition-->
          <!--            enter-active-class="ease-out duration-300"-->
          <!--            enter-class="opacity-0 scale-90"-->
          <!--            enter-to-class="opacity-100 scale-100"-->
          <!--            leave-active-class="ease-in duration-200"-->
          <!--            leave-class="opacity-100 scale-100"-->
          <!--            leave-to-class="opacity-0 scale-90"-->
          <!--          >-->
          <!--            <circle-->
          <!--              v-show="show('STAGE')"-->
          <!--              cx="540"-->
          <!--              cy="235"-->
          <!--              r="350"-->
          <!--              style="fill: url(#shadow)"-->
          <!--            ></circle>-->
          <!--          </transition>-->
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              @mouseout="outIcon('STAGE')"
              @click="$router.push('/live')"
              style="filter:url(#shadowFilter)"
              v-show="show('STAGE')"
              width="400"
              xlink:href="/images/STAGE_cutout.png"
              x="342"
              y="60"
              overflow="visible"
            ></image>
          </transition>

          <!-- TEAM -->
          <circle
            class="cursor-pointer"
            @mouseover="overIcon('TEAM')"
            id="team_hit_circle"
            opacity="0.0"
            fill="white"
            cx="380"
            cy="300"
            r="100"
          ></circle>
          <!--          <transition-->
          <!--            enter-active-class="ease-out duration-300"-->
          <!--            enter-class="opacity-0 scale-90"-->
          <!--            enter-to-class="opacity-100 scale-100"-->
          <!--            leave-active-class="ease-in duration-200"-->
          <!--            leave-class="opacity-100 scale-100"-->
          <!--            leave-to-class="opacity-0 scale-90"-->
          <!--          >-->
          <!--            <circle-->
          <!--              v-show="show('TEAM')"-->
          <!--              cx="400"-->
          <!--              cy="305"-->
          <!--              r="450"-->
          <!--              style="fill: url(#shadow)"-->
          <!--            ></circle>-->
          <!--          </transition>-->
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              style="filter:url(#shadowFilter)"
              @mouseout="outIcon('TEAM')"
              @click="$router.push('/team')"
              v-show="show('TEAM')"
              width="373"
              xlink:href="/images/TEAM_cutout_NEW.png"
              x="194"
              y="110"
              overflow="visible"
            ></image>
          </transition>

          <!-- SPEAKERS -->
          <circle
            class="cursor-pointer"
            @mouseover="overIcon('SPEAKERS')"
            id="speakers_hit_circle"
            opacity="0.0"
            fill="white"
            cx="100"
            cy="482"
            r="100"
          ></circle>
          <!--          <transition-->
          <!--            enter-active-class="ease-out duration-300"-->
          <!--            enter-class="opacity-0 scale-90"-->
          <!--            enter-to-class="opacity-100 scale-100"-->
          <!--            leave-active-class="ease-in duration-200"-->
          <!--            leave-class="opacity-100 scale-100"-->
          <!--            leave-to-class="opacity-0 scale-90"-->
          <!--          >-->
          <!--            <circle-->
          <!--              v-show="show('SPEAKERS')"-->
          <!--              cx="100"-->
          <!--              cy="482"-->
          <!--              r="300"-->
          <!--              style="fill: url(#shadow)"-->
          <!--            ></circle>-->
          <!--          </transition>-->
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              @mouseout="outIcon('SPEAKERS')"
              @click="$router.push('/speakers')"
              style="filter:url(#shadowFilter)"
              v-show="show('SPEAKERS')"
              width="444"
              xlink:href="/images/SPEAKERS_Cutout.png"
              x="-100"
              y="210"
              overflow="visible"
            ></image>
          </transition>

          <!-- Workshop -->
          <circle
            class="cursor-pointer"
            @mouseover="() => overIcon('WORKSHOP')"
            id="workshop_circle"
            opacity="0.0"
            fill="white"
            cx="360"
            cy="482"
            r="100"
          ></circle>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              @mouseout="outIcon('WORKSHOP')"
              @click="$router.push('/tour')"
              v-show="show('WORKSHOP')"
              style="filter:url(#shadowFilter)"
              width="450"
              xlink:href="/images/WORKSHOP_TOUR_Cutout.png"
              x="150"
              y="330"
              overflow="visible"
            ></image>
          </transition>

          <!-- SHOW & TEL -->
          <circle
            class="cursor-pointer"
            @mouseover="() => overIcon('GALLERY')"
            id="gallery_hit_circle"
            opacity="0.0"
            fill="white"
            cx="620"
            cy="500"
            r="100"
          ></circle>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              @mouseout="outIcon('GALLERY')"
              @click="$router.push('/userProjects')"
              style="filter:url(#shadowFilter)"
              v-show="show('GALLERY')"
              width="390"
              xlink:href="/images/SHOW_TELL_cutout.png"
              x="385"
              y="260"
              overflow="visible"
            ></image>
          </transition>

          <!-- CHAT -->
          <circle
            class="cursor-pointer"
            @mouseover="() => overIcon('CHAT')"
            id="gallery_hit_circle"
            opacity="0.0"
            fill="white"
            cx="440"
            cy="740"
            r="120"
          ></circle>
          <transition
            enter-active-class="ease-out duration-300"
            enter-class="opacity-0 scale-90"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="ease-in duration-200"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-90"
          >
            <image
              class="cursor-pointer"
              @mouseout="outIcon('CHAT')"
              @click="$router.push('/social')"
              style="filter:url(#shadowFilter)"
              v-show="show('CHAT')"
              width="574"
              xlink:href="/images/CHAT_cutout.png"
              x="110"
              y="461"
              overflow="visible"
            ></image>
          </transition>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import PaperAgenda from "../components/PaperAgenda";
export default {
  name: "FestivalHome",
  components: { PaperAgenda },
  data() {
    return {
      shown: ""
    };
  },
  methods: {
    show(icon) {
      return icon === this.shown;
    },
    overIcon(icon) {
      this.shown = icon;
    },
    outIcon(icon) {
      if (this.shown === icon) {
        this.shown = "";
      }
    }
  }
};
</script>

<style scoped>
#agenda {
  background-image: url("/images/ScheduleCropped.png");
}
#texture-block {
  background-image: url("/images/LightPaper_Background.jpg");
}
.text-massive {
  font-size: 66pt;
}
.rounded-xl {
  border-radius: 2rem;
}
.w-40pc {
  width: 40%;
}
.w-45pc {
  width: 45%;
}
.w-60pc {
  width: 60%;
}
</style>
